export const selectConfigurationState = (state) => state.common || {};

export const selectConfigurationData = (state) =>
  selectConfigurationState(state).configurationData || null;

export const selectConfigurationResponse = (state) =>
  selectConfigurationState(state).configurationResponse || null;

export const selectConfigurationLoading = (state) =>
  Boolean(selectConfigurationState(state).configurationLoading);

export const selectConfigurationInitialized = (state) =>
  Boolean(selectConfigurationState(state).configurationInitialized);

export const selectConfigurationValue = (state, key, fallback = "") => {
  const configurationData = selectConfigurationData(state);

  return configurationData?.[key] ?? fallback;
};
